module.exports = __webpack_public_path__ + "0af1727ae9198ebfe2aa8c85fc95cd89.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cvcFront.png
// module id = 1804
// module chunks = 1